import { toast } from "sonner";
import { Copy, KeyRound } from "lucide-react";
import { Button } from "@/components/ui/button";
import { fmtDateTime } from "@/lib/format";
import { cn } from "@/lib/utils";

export const spaced = (c) => c.split("").join(" ");

/** Small chip for lists and cards; "—" when no code was issued. */
export const CodeChip = ({ code, className, testid }) => (
  code
    ? <span className={cn("inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2 py-0.5 font-mono text-[11px] font-bold tracking-wider text-emerald-800 ring-1 ring-emerald-200", className)} data-blur data-testid={testid}><KeyRound className="h-3 w-3" />{code}</span>
    : <span className={cn("text-[11px] text-slate-400", className)} data-testid={testid}>—</span>
);

const copy = (code) => navigator.clipboard.writeText(code).then(() => toast.success("Approval code copied")).catch(() => toast.error("Couldn't copy; select the code instead"));

/** Prominent badge on the request detail page. */
export const CodeBadge = ({ info }) => (
  <div className="mt-4 flex flex-wrap items-center gap-4 rounded-2xl border-2 border-dashed border-emerald-300 bg-emerald-50 px-4 py-3" data-testid="approval-code-badge">
    <div>
      <div className="text-[11px] font-bold uppercase tracking-[0.18em] text-emerald-800">Approval code</div>
      <div className="mt-0.5 select-all font-mono text-3xl font-bold tracking-[0.3em] text-slate-900" data-blur data-testid="approval-code">{spaced(info.code)}</div>
      <div className="mt-0.5 text-xs text-emerald-900/80">Issued {fmtDateTime(info.issued_at)} by {info.issued_by}{info.retroactive && " · issued retroactively"}</div>
    </div>
    <Button type="button" variant="outline" className="ml-auto h-11 gap-1.5 border-emerald-300 bg-white text-emerald-800 hover:bg-emerald-100" onClick={() => copy(info.code)} data-testid="approval-code-copy">
      <Copy className="h-4 w-4" /> Copy
    </Button>
  </div>
);
